module.exports = __webpack_public_path__ + "img/ETHNIC NECKLACE GREEN.9f89cfe.svg";